/**
 * 图片文件内容哈希（用于跨入口去重，避免同一文件多次写入图片空间）
 */

export async function sha256HexFromArrayBuffer(buffer) {
  if (!buffer || !crypto?.subtle?.digest) return '';
  try {
    const hashBuffer = await crypto.subtle.digest('SHA-256', buffer);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    return hashArray.map((b) => b.toString(16).padStart(2, '0')).join('');
  } catch {
    return '';
  }
}

export async function sha256HexFromFile(file) {
  if (!file || typeof file.arrayBuffer !== 'function') return '';
  try {
    const buf = await file.arrayBuffer();
    return sha256HexFromArrayBuffer(buf);
  } catch {
    return '';
  }
}
